export function assert(condition: unknown, message: string): asserts condition {
  if (!condition) {
    throw new Error(`Assertion failed: ${message}`);
  }
}

export function unreachable(value: never, message = 'Unreachable case'): never {
  throw new Error(`${message}: ${JSON.stringify(value)}`);
}
